jQuery(function ($) {
    $('#checkout-register-btn').click(function (e) {
        document.getElementById('welcomeDiv').style.display = "block";
        document.getElementById("checkout-password").required = true;
        document.getElementById("checkout-confirm-password").required = true;
    });
})